import React from 'react';
import { useTranslation } from 'react-i18next';

import Input from '../../common/Input';

const Contacts = ({
  formData,
  invalidFields,
  handleChange,
  handleBlur,

  isItalia
}) => {
  const { t } = useTranslation();

  return <div className='customer__form__data data--contact'>
    <Input
      type='tel'
      name='phone'
      label={t('customer.form.phone.label')}
      value={formData.phone}
      invalid={invalidFields['phone']}
      onChange={handleChange}
      onBlur={handleBlur}
    />
    <Input
      type='email'
      name='email'
      label={t('customer.form.email.label')}
      value={formData.email}
      invalid={invalidFields['email']}
      onChange={handleChange}
      onBlur={handleBlur}
    />
    {isItalia && ['company', 'sole-proprietorship'].includes(formData.type) && (<>
      <Input
        type='email'
        name='pec'
        label={t('customer.form.pec.label')}
        value={formData.pec}
        invalid={invalidFields['pec']}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <Input
        type='text'
        name='SDICode'
        label={t('customer.form.SDICode.label')}
        value={formData.SDICode}
        invalid={invalidFields['SDICode']}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </>)}
  </div>;
};

export default Contacts;